/**
 * What an incoming message is allowed to DO to the user — the one place that
 * decides, so the realtime hook cannot drift from what the mute menu promises.
 *
 * Muting is per conversation and per viewer (`channel.muted`, set by
 * `PUT /chat/channels/:id/mute`). It suppresses the two things that interrupt:
 * the chime and the OS notification. It deliberately does NOT suppress the
 * unread count — a muted conversation still has to say that it has unread
 * messages, or muting would silently hide mail. That is the Telegram/Slack
 * split, and it is why this returns three flags rather than one.
 */

/** True only for an explicit `muted: true` — an absent field is not muted. */
export function isChannelMuted(channel) {
  return channel?.muted === true;
}

/**
 * @param channel  the channel row (may be null — an unknown channel is unmuted)
 * @param prefs    preferencesStore state; `notificationSound` /
 *                 `desktopNotifications` are opt-OUT (undefined means on)
 * @param hasFocus is the app window focused right now
 * @returns {{ unread: boolean, sound: boolean, toast: boolean }}
 */
export function messageAlerts({ channel, prefs = {}, hasFocus = false } = {}) {
  const muted = isChannelMuted(channel);
  return {
    // Always: see above.
    unread: true,
    sound: !muted && prefs.notificationSound !== false,
    // OS toast only when the app isn't focused (Discord/Teams behaviour): if
    // the window is up, the badge + chime already covered it.
    toast: !muted && prefs.desktopNotifications !== false && !hasFocus,
  };
}
